import { SVGProps } from 'react'

export const NeImageSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g fill='none' fillRule='evenodd'>
      <g>
        <path
          d='m14.438 1.5 6 6v12.75a2.25 2.25 0 0 1-2.25 2.25H5.813a2.25 2.25 0 0 1-2.25-2.25V3.75a2.25 2.25 0 0 1 2.25-2.25h8.625Zm-1.02 9.627a.272.272 0 0 0-.38.068l-2.434 3.501-1.007-1.456a.272.272 0 0 0-.448 0l-1.932 2.791a.272.272 0 0 0 .224.427h9.183a.272.272 0 0 0 .223-.427l-3.36-4.836a.272.272 0 0 0-.069-.068Zm-3.91-1.002a.75.75 0 1 0 0 1.498.75.75 0 0 0 0-1.498Z'
          fill='#F7AD2D'
        />
        <path
          d='M14.438 1.5V6a1.5 1.5 0 0 0 1.5 1.5h4.5l-6-6Z'
          fill='#FBDAA0'
        />
      </g>
    </g>
  </svg>
)
